import { Typography } from "@material-ui/core"

const Base = (props) => {

  return ( <>
    <Typography>
      Yes! If you need your song ASAP, you can add our expedited option at checkout. This guarantees you’ll receive the final song within 48 hours after lyric approval instead of the standard 7-day turnaround. Perfect for last-minute surprises, spontaneous proposals, or when you just <i>can’t wait</i> to hear your song!
    </Typography>
  </> )
}

export default Base
